export const IconNames = {
  success: "Success",
  error: "Close",
  warning: "Warning",
  info: "Info"
}
export const getIconColor = (type: string) => {
  switch (type) {
    case "success":
      return "bg-[#33962f] text-white"
    case "error":
      return "bg-red-500 text-red-200"
    case "warning":
      return "bg-yellow-500 text-yellow-200"
    case "info":
      return "bg-blue-500 text-blue-200"
  }
}
